'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../common');

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseGeneratedDocxActivity = (_dec = (0, _mobxReact.inject)('CaseStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseGeneratedDocxActivity, _Component);

  function CaseGeneratedDocxActivity() {
    _classCallCheck(this, CaseGeneratedDocxActivity);

    return _possibleConstructorReturn(this, (CaseGeneratedDocxActivity.__proto__ || Object.getPrototypeOf(CaseGeneratedDocxActivity)).apply(this, arguments));
  }

  _createClass(CaseGeneratedDocxActivity, [{
    key: 'download',
    value: function download() {
      var _props = this.props,
          CaseStore = _props.CaseStore,
          _props$activity = _props.activity,
          _case = _props$activity.case,
          download_url = _props$activity.download_url;


      CaseStore.onCaseGeneratedDocxActivityDownloadClick(_case, download_url);
    }
  }, {
    key: 'render',
    value: function render() {
      var activity = this.props.activity,
          link = _react2.default.createElement(
        _Button2.default,
        { bsStyle: 'link', onClick: this.download },
        _react2.default.createElement(_common.Icon, { type: 'download' }),
        activity.name
      ),
          body = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _Row2.default,
          null,
          'Generated payoff'
        ),
        _react2.default.createElement(
          _Row2.default,
          { className: 'files' },
          link
        )
      );


      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: body,
        dot: 'small'
      }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseGeneratedDocxActivity;
}(_react.Component), _class2.propTypes = {
  activity: _propTypes2.default.shape({ id: _propTypes2.default.string.isRequired, type: _propTypes2.default.string.isRequired }).isRequired,
  CaseStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = CaseGeneratedDocxActivity;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseGeneratedDocxActivity, 'CaseGeneratedDocxActivity', '/app/src/components/common-activities/CaseGeneratedDocxActivity.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/CaseGeneratedDocxActivity.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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